import { createSlice  } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "preview",
  initialState: {
    // settings: {},
    hoverMode: false,
    popupMode: false,
    mode: false
  },
  reducers: {
    setPreviewHoverMode: (preview, action) => {
      preview.hoverMode = action.payload;
    },
    setPreviewPopupMode: (preview, action) => {
      preview.popupMode = action.payload;
    },
    setPreviewMode: (preview, action) => {
      preview.mode = action.payload;
    }
  }
});

export const { setPreviewHoverMode, setPreviewPopupMode, setPreviewMode } = slice.actions;
export default slice.reducer;